import type { ItemCategory } from "@/lib/types";
import { emptyFamilySpecs } from "@/lib/listing/listingFamilyRuntime";
import type { SellListingFormData } from "@/lib/listing/sellListingFormTypes";

/** Empty sell listing form — shared by create and edit sell flows. */
export function createEmptySellListingFormData(): SellListingFormData {
  return {
    title: "",
    description: "",
    defects: "",
    price: "",
    quantity: 1,
    category: "" as ItemCategory,
    subcategory: "",
    location: "",
    locationIds: null,
    images: [],
    pickupAvailability: [],
    pickupStartHour: "9",
    pickupEndHour: "17",
    pickupDays: [],
    brand: "",
    size: "",
    model: "",
    familySpecs: emptyFamilySpecs(),
  };
}
